<template>
  <div>
    <a-drawer
      :maskClosable="false"
      width="80%"
      title="维修配置"
      placement="right"
      :closable="true"
      :visible="visible"
      @close="onClose"
    >
      <a-tabs default-active-key="1" @change="handleTabChange">
        <a-tab-pane key="1" tab="维修区域">
          <a-card :bordered="false">
            <div class="table-operations">
              <template>
                <a-button type="primary" @click="handleAddArea" v-hasPermi="['upkeep:point:add']">
                  <a-icon type="plus" />新增
                </a-button>

                <a-button
                  type="danger"
                  :disabled="areaMultiple"
                  @click="handleBatchDeleteArea"
                  v-hasPermi="['upkeep:point:remove']"
                >
                  <a-icon type="delete" />批量删除
                </a-button>
              </template>
            </div>
            <a-table
              :loading="areaLoading"
              rowKey="id"
              :columns="areaColumns"
              :data-source="areaList"
              :pagination="false"
              :row-selection="areaRowSelection"
            >
              <span slot="createTime" slot-scope="record">
                {{ record }}
              </span>
              <span slot="operation" slot-scope="text, record">
                <a @click="handleAreaDetail(record)" v-hasPermi="['upkeep:point:query']">详情</a>
                <a-divider type="vertical" v-hasPermi="['upkeep:point:query', 'upkeep:point:remove']" />
                <a @click="handleAreaDelete(record)" v-hasPermi="['upkeep:point:remove']">删除</a>
              </span>
            </a-table>
            <a-pagination
              class="ant-table-pagination"
              show-size-changer
              :current="areaQueryParam.pageNum"
              :total="areaTotal"
              :page-size="areaQueryParam.pageSize"
              @showSizeChange="onAreaShowSizeChange"
              @change="onAreaChangeSize"
            />
          </a-card>
        </a-tab-pane>
        <a-tab-pane key="2" tab="维修分类">
          <a-card :bordered="false">
            <div class="table-operations">
              <template>
                <a-button type="primary" @click="handleAddCategory" v-hasPermi="['upkeep:category:tenant:add']">
                  <a-icon type="plus" />新增
                </a-button>

                <a-button
                  type="danger"
                  :disabled="categoryMultiple"
                  @click="handleBatchDeleteCategory"
                  v-hasPermi="['upkeep:category:tenant:remove']"
                >
                  <a-icon type="delete" />批量删除
                </a-button>

                <a-button type="primary" @click="handleExport" v-hasPermi="['upkeep:category:tenant:export']">
                  <a-icon type="download" /> 导出
                </a-button>
              </template>
            </div>
            <a-table
              :loading="categoryLoading"
              rowKey="id"
              :columns="categoryColumns"
              :data-source="categoryList"
              :pagination="false"
              :row-selection="categoryRowSelection"
            >
              <span slot="sort" slot-scope="text, record">
                {{ record.sort }}
              </span>
              <span slot="createTime" slot-scope="text, record">
                {{ record.createTime }}
              </span>
              <span slot="operation" slot-scope="text, record">
                <a @click="handleCategoryDelete(record)" v-hasPermi="['upkeep:category:tenant:remove']">删除</a>
              </span>
            </a-table>
            <a-pagination
              class="ant-table-pagination"
              show-size-changer
              :current="categoryQueryParam.pageNum"
              :total="categoryTotal"
              :page-size="categoryQueryParam.pageSize"
              @showSizeChange="onCategoryShowSizeChange"
              @change="onCategoryChangeSize"
            />
          </a-card>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>

    <!-- 维修区域表单 -->
    <area-form ref="areaForm" @ok="getAreaList" />
    <!-- 维修区域详情 -->
    <reginDetail ref="reginDetail"></reginDetail>

    <!-- 维修分类表单 -->
    <tenant-point-form ref="tenantPointForm" @ok="getCategoryList" />
  </div>
</template>

<script>
import { fetchList, delObjAll, delObj, getObj } from '@/api/repairModule/repairArea'
import { listTenantCategory, delTenantCategory } from '@/api/system/tenantCategory'
import { tableMixin } from '@/store/table-mixin'
import areaForm from './areaForm'
import reginDetail from './reginDetail.vue'
import TenantPointForm from './tenantPointForm'

export default {
  mixins: [tableMixin],
  components: {
    areaForm,
    reginDetail,
    TenantPointForm,
  },
  data() {
    return {
      visible: false,
      currentTenantId: undefined,
      // 维修区域相关
      areaList: [],
      areaLoading: false,
      areaTotal: 0,
      areaSelectedRowKeys: [],
      areaSelectedRows: [],
      areaMultiple: true,
      areaQueryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantId: undefined,
      },
      areaColumns: [
        { title: '省', dataIndex: 'province', align: 'center', width: 120 },
        { title: '市', dataIndex: 'city', align: 'center' },
        { title: '区', dataIndex: 'area', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', scopedSlots: { customRender: 'createTime' } },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      // 维修分类相关
      categoryList: [],
      categoryLoading: false,
      categoryTotal: 0,
      categorySelectedRowKeys: [],
      categorySelectedRows: [],
      categoryMultiple: true,
      categoryQueryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantId: undefined,
      },
      categoryColumns: [
        {
          title: '分类名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '排序号',
          dataIndex: 'sort',
          align: 'center',
          scopedSlots: { customRender: 'sort' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  computed: {
    areaRowSelection() {
      return {
        selectedRowKeys: this.areaSelectedRowKeys,
        onChange: this.onAreaSelectChange,
        onSelect: this.onAreaSelect,
        onSelectAll: this.onAreaSelectAll,
      }
    },
    categoryRowSelection() {
      return {
        selectedRowKeys: this.categorySelectedRowKeys,
        onChange: this.onCategorySelectChange,
        onSelect: this.onCategorySelect,
        onSelectAll: this.onCategorySelectAll,
      }
    },
  },
  methods: {
    init(record) {
      this.visible = true
      this.currentTenantId = record.id
      this.areaQueryParam.tenantId = record.id
      this.categoryQueryParam.tenantId = record.id
      // 默认加载第一个 tab 的数据
      this.getAreaList()
    },
    onClose() {
      this.visible = false
      this.areaSelectedRowKeys = []
      this.areaSelectedRows = []
      this.categorySelectedRowKeys = []
      this.categorySelectedRows = []
    },
    handleTabChange(activeKey) {
      // 切换 tab 时加载对应数据
      if (activeKey === '1' && this.areaList.length === 0) {
        this.getAreaList()
      } else if (activeKey === '2' && this.categoryList.length === 0) {
        this.getCategoryList()
      }
    },
    // 维修区域相关方法
    getAreaList() {
      this.areaLoading = true
      fetchList(this.areaQueryParam)
        .then((res) => {
          this.areaList = res.data.records.map((item) => ({
            ...item,
            tenantId: item.tenantId || this.areaQueryParam.tenantId,
          }))
          this.areaTotal = res.data.total
          this.areaLoading = false
        })
        .catch(() => {
          this.areaLoading = false
        })
    },
    onAreaShowSizeChange(current, pageSize) {
      this.areaQueryParam.pageSize = pageSize
      this.getAreaList()
    },
    onAreaChangeSize(current, pageSize) {
      this.areaQueryParam.pageNum = current
      this.areaQueryParam.pageSize = pageSize
      this.getAreaList()
    },
    onAreaSelectChange(selectedRowKeys, selectedRows) {
      this.areaSelectedRowKeys = selectedRowKeys
      this.areaSelectedRows = selectedRows
      this.areaMultiple = !selectedRowKeys.length
    },
    onAreaSelect(record, selected, selectedRows) {
      this.areaSelectedRows = selectedRows
    },
    onAreaSelectAll(selected, selectedRows, changeRows) {
      this.areaSelectedRows = selectedRows
    },
    handleAddArea() {
      if (this.$refs.areaForm && this.areaQueryParam.tenantId) {
        this.$refs.areaForm.handleAdd(this.areaQueryParam.tenantId)
      }
    },
    handleBatchDeleteArea() {
      if (this.areaSelectedRowKeys.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      const ids = this.areaSelectedRows.map((item) => item.id)
      const that = this

      this.$confirm({
        title: '确认批量删除',
        content: `确定要删除选中的 ${this.areaSelectedRowKeys.length} 条数据吗？`,
        onOk() {
          return delObjAll(ids).then(() => {
            that.areaSelectedRowKeys = []
            that.areaSelectedRows = []
            that.getAreaList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    handleAreaDetail(record) {
      if (this.$refs.reginDetail && record.id) {
        // 使用维修区域的API获取详情
        getObj(record.id)
          .then((res) => {
            if (res.data) {
              this.$refs.reginDetail.init(res.data, 1)
            }
          })
          .catch(() => {
            this.$message.error('获取详情失败')
          })
      }
    },
    handleAreaDelete(record) {
      const that = this
      this.$confirm({
        title: '确认删除',
        content: `是否确认删除该维修区域?`,
        onOk() {
          const ids = [record.id]
          return delObj(ids)
            .then(() => {
              that.getAreaList()
              that.$message.success('删除成功')
            })
            .catch((error) => {
              console.error('删除失败:', error)
              that.$message.error('删除失败')
            })
        },
        onCancel() {},
      })
    },
    // 维修分类相关方法
    getCategoryList() {
      this.categoryLoading = true
      listTenantCategory(this.categoryQueryParam)
        .then((res) => {
          this.categoryList = res.data.records
          this.categoryTotal = res.data.total
          this.categoryLoading = false
        })
        .catch(() => {
          this.categoryLoading = false
        })
    },
    onCategoryShowSizeChange(current, pageSize) {
      this.categoryQueryParam.pageSize = pageSize
      this.getCategoryList()
    },
    onCategoryChangeSize(current, pageSize) {
      this.categoryQueryParam.pageNum = current
      this.categoryQueryParam.pageSize = pageSize
      this.getCategoryList()
    },
    onCategorySelectChange(selectedRowKeys, selectedRows) {
      this.categorySelectedRowKeys = selectedRowKeys
      this.categorySelectedRows = selectedRows
      this.categoryMultiple = !selectedRowKeys.length
    },
    onCategorySelect(record, selected, selectedRows) {
      this.categorySelectedRows = selectedRows
    },
    onCategorySelectAll(selected, selectedRows, changeRows) {
      this.categorySelectedRows = selectedRows
    },
    handleAddCategory() {
      if (this.$refs.tenantPointForm && this.categoryQueryParam.tenantId) {
        this.$refs.tenantPointForm.handleAdd(this.categoryQueryParam.tenantId)
      }
    },
    handleCategoryDelete(record) {
      const that = this
      this.$confirm({
        title: '确认删除',
        content: `是否确认删除分类"${record.name}"?`,
        onOk() {
          const deleteData = {
            ids: [record.id],
            tenantId: that.categoryQueryParam.tenantId,
          }

          return delTenantCategory(deleteData)
            .then(() => {
              that.getCategoryList()
              that.$message.success('删除成功')
            })
            .catch((error) => {
              console.error('删除失败:', error)
              that.$message.error('删除失败')
            })
        },
        onCancel() {},
      })
    },
    handleBatchDeleteCategory() {
      if (this.categorySelectedRowKeys.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      const that = this
      this.$confirm({
        title: '确认批量删除',
        content: `确定要删除选中的 ${this.categorySelectedRowKeys.length} 条数据吗？`,
        onOk() {
          const deleteData = {
            ids: that.categorySelectedRowKeys,
            tenantId: that.categoryQueryParam.tenantId,
          }

          return delTenantCategory(deleteData)
            .then(() => {
              that.categorySelectedRowKeys = []
              that.categorySelectedRows = []
              that.getCategoryList()
              that.$message.success('删除成功')
            })
            .catch((error) => {
              console.error('批量删除失败:', error)
              that.$message.error('批量删除失败')
            })
        },
        onCancel() {},
      })
    },
    handleExport() {
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk: () =>
          this.download(
            'upkeep/category/tenant/export',
            { ...this.categoryQueryParam },
            `维修分类关联租户列表_${new Date().getTime()}.xlsx`
          ),
      })
    },
  },
}
</script>

<style scoped>
.ant-table-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
